export interface Scenario {
  id: string;
  title: string;
  description: string;
  imageUrl: string;
  iconUrl: string;
}

export const SCENARIOS: Scenario[] = [
  {
    id: "accident-responsable",
    title: "Accident responsable",
    description:
      "Vous percutez le véhicule devant vous, vous abimez votre carrosserie sur une borne en béton, vous êtes à l’origine d’un accident responsable.",
    imageUrl: "/assets/pack-zero-franchise/scenario-accident.png",
    iconUrl: "/assets/pack-zero-franchise/icons/scenario-accident.svg",
  },
  {
    id: "bris-de-glace",
    title: "Bris de glace",
    description:
      "Bris accidentel du pare-brise, lunette arrière, glaces latérales, blocs optiques ou du toit ouvrant de votre véhicule.",
    imageUrl: "/assets/pack-zero-franchise/scenario-bris-glace.png",
    iconUrl: "/assets/pack-zero-franchise/icons/scenario-bris-glace.svg",
  },
  {
    id: "choc-animal",
    title: "Choc contre animal",
    description:
      "Dommage matériel subi par votre véhicule suite à un accident avec un animal sauvage.",
    imageUrl: "/assets/pack-zero-franchise/scenario-animal.png",
    iconUrl: "/assets/pack-zero-franchise/icons/scenario-choc-animal.svg",
  },
  {
    id: "vol",
    title: "Vol ou tentative de vol",
    description:
      "Vol de votre voiture commis par effraction ou suite à un acte de violence / commencement d’exécution (forcement de serrure, du contact...)",
    imageUrl: "/assets/pack-zero-franchise/scenario-vol.png",
    iconUrl: "/assets/pack-zero-franchise/icons/scenario-vol.svg",
  },
  {
    id: "incendie",
    title: "Incendie",
    description: "Votre véhicule subit un incendie par embrasement, foudre, explosion.",
    imageUrl: "/assets/pack-zero-franchise/scenario-incendie.png",
    iconUrl: "/assets/pack-zero-franchise/icons/scenario-incendie.svg",
  },
  {
    id: "evenements-climatiques",
    title: "Événements climatiques",
    description:
      "La grêle abîme votre carrosserie, une tempête fait tomber une branche sur votre véhicule, une inondation cause des dégâts.",
    imageUrl: "/assets/pack-zero-franchise/scenario-climat.png",
    iconUrl: "/assets/pack-zero-franchise/icons/scenario-climat.svg",
  },
];
